import axios from 'axios'
import store from '../store'

class API {

  constructor(storeData) {
    this.instance = axios.create({ withCredentials: true })
    
    // Request interceptor to attach access token
    this.instance.interceptors.request.use((config) => {
      const token = sessionStorage.getItem("access_token")
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    }, (error) => {
      console.log("Could not initiate API request interceptor:", error)
      return Promise.reject(error)
    })

    // Response interceptor to handle token refresh on 401
    this.instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config
        const endpoint = originalRequest ? originalRequest.headers.endpoint : null
        const isPublicRoute = ['/signup', '/install'].includes(window.location.pathname)
        
        if (error.response && error.response.status === 401 && originalRequest && !originalRequest._retry && endpoint !== "/refresh-token" && !isPublicRoute) {
          originalRequest._retry = true
          try {
            // Get current active user from IndexedDB store to refresh for that active role
            const currentStore = await store.get()
            const payload = {}
            if (currentStore && currentStore.users && currentStore.users.length) {
              const activeUser = currentStore.users[currentStore.index]
              payload.userID = activeUser.id
              payload.roleID = activeUser.roleID
              payload.cachedUsers = currentStore.users.map(u => ({ id: u.id, roleID: u.roleID }))
            }
            
            // Call refresh-token
            const refreshRes = await this.instance.post('/api', payload, {
              headers: { endpoint: '/refresh-token' }
            })
            
            const { access_token } = refreshRes.data
            sessionStorage.setItem("access_token", access_token)
            
            // Retry the original request with the new token
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            return this.instance(originalRequest)
          } catch (refreshError) {
            // Refresh token failed/expired -> clear store and redirect to login
            await store.clear()
            sessionStorage.removeItem("access_token")
            window.location.href = `/?redirect=${window.location.pathname}`
            return Promise.reject(refreshError)
          }
        }

        if (error.response && error.response.status === 503) {
          window.dispatchEvent(new CustomEvent('maintenance-mode-active', { detail: error.response.data }))
        }

        return Promise.reject(error)
      }
    )
  }

  async call(endpoint, body) {
    return this.instance.post('/api', body, { headers: { endpoint } })
  }
}


export default API